package main.kotlin.data

data class AppConfig(var minimumDocumentCount:Int,var minimumVersion:String?,var url:String?)
{
    constructor(dyn:dynamic) : this(dyn.minimum_document_count as? Int ?: 10,dyn.minimum_version as? String,dyn.url as? String)
}
